module.exports = __webpack_public_path__ + "static/media/github.0908d0b8.png";